import { render } from "./MemoList.vue?vue&type=template&id=670d4e96&ts=true"
import script from "./MemoList.vue?vue&type=script&lang=ts"
export * from "./MemoList.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__